export function updateSurveyState(state, payload) {
  state[payload.state] = payload.data;
}
